
<template>
    <label class="w-100" v-if="label" :id="`input-${name}-label`" :for="`input${name}`" :class="[labelClass, {'required': required}]">
    {{ $t(label) }}
    </label>
</template>

<script setup>

  const props = defineProps( {
    name: String,
    required: {type:Boolean, default: true},
    labelClass: {type:String, default: "form-label fs-6 fw-bolder"},
    label: String,
  })

</script>
<style>
.left-align {
  text-align: left;
}
</style>